module.exports = __webpack_public_path__ + "static/media/icon-pending.82704a42.svg";